import React from 'react';
import './ui.css';

/**
 * RoleBadge — pill indicating which side of a transaction the current view represents.
 * Props: role: 'buyer' | 'seller' | 'shared', label?
 */
const DEFAULT_LABELS = {
  buyer: 'Buyer view',
  seller: 'Seller view',
  shared: 'Shared',
};

export default function RoleBadge({ role = 'shared', label }) {
  const text = label ?? DEFAULT_LABELS[role] ?? 'Shared';
  return (
    <span className={`ui-role-badge ui-role-badge--${role}`}>{text}</span>
  );
}
